import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '3f9f64b6-65b5-493d-a174-da6977cf6f6c',
    authority: 'https://login.microsoftonline.com/dc123ab4-b91f-496f-b8ce-b6fd4fe73093',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/login',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const graphRequest = {
  scopes: ['User.Read', 'GroupMember.Read.All'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
